import React, { useEffect, useState } from "react";
import AudioPlayer from "../../audioPlayer";
import Cookies from "js-cookie";
import { useUserPermissions } from "../../../../UserPermissionsContext";

interface CallLog {
  employee_name: string;
  employee_branch: string;
  agent_name: string;
  call_start_time_: string;
  call_end_time_: string;
  call_duration_hms: string;
  conversation_duration_hms: string;
  caller_status: string;
  destination_status: string;
  call_status: string;
  aws_call_recording_file: string | null;
  service_division_name: string;
}

interface SedCallLogsProps {
  teacherId: number;
}

const SedCallLogs: React.FC<SedCallLogsProps> = ({ teacherId }) => {
  const jwtToken = Cookies.get("authToken");
  const { userPermissions, webApi } = useUserPermissions();
  const [callLogs, setCallLogs] = useState<CallLog[]>([]);
  const [loading, setLoading] = useState(false);

  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  const dummyData =
{
    "message": "Data successfully obtained",
    "results": [
        {
            "service_division": "SED Calling",
            "call_history": [
                {
                    "employee_name": "BATTULA SRI LAKSHMI",
                    "employee_branch": "KHAMMAM",
                    "agent_name": "mohan",
                    "call_start_time_": "2026-07-02 15:58:33",
                    "call_end_time_": "2026-07-02 15:59:20",
                    "call_duration_hms": "00:00:47",
                    "conversation_duration_hms": "00:00:00",
                    "caller_status": "Answered",
                    "destination_status": "Missed",
                    "call_status": "Missed",
                    "aws_call_recording_file": null,
                    "service_division_name": "SED Calling"
                },
                {
                    "employee_name": "BATTULA SRI LAKSHMI",
                    "employee_branch": "KHAMMAM",
                    "agent_name": "mohan",
                    "call_start_time_": "2026-07-02 15:53:14",
                    "call_end_time_": "2026-07-02 15:54:02",
                    "call_duration_hms": "00:00:48",
                    "conversation_duration_hms": "00:00:00",
                    "caller_status": "Answered",
                    "destination_status": "Missed",
                    "call_status": "Missed",
                    "aws_call_recording_file": null,
                    "service_division_name": "SED Calling"
                }
            ]
        }
    ]
}


  const fetchCallLogs = async () => {
    try {
      setLoading(true);

      const res = await fetch(
        `${webApi}/call/teacher_wise_call_logs/${teacherId}/`, options
      );

      const data = await res.json();

      // response: results[0].call_history
      const logs = data?.results?.[0]?.call_history || [];
      // const logs = dummyData.results?.[0]?.call_history || [];
      
      setCallLogs(logs);
    } catch (error) {
      console.error("Failed to fetch call logs:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (teacherId) {
      fetchCallLogs();
    }
  }, [teacherId]);

  return (
    <div>
      {loading && <p>Loading call logs...</p>}

      {!loading &&  (
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-body">
                {callLogs.length === 0 ? (
                  <p>No call logs found</p>
                ) : (
                  <ul className="timeline">
                    {callLogs.map((call, index) => {
                      const isCallerAnswered =
                        call.caller_status.toLowerCase() === "answered";

                      const isDestinationAnswered =
                        call.destination_status.toLowerCase() === "answered";

                      const badgeColor =
                        isCallerAnswered && isDestinationAnswered
                          ? "success"
                          : "danger";

                      const agentIcon = isCallerAnswered
                        ? "fas fa-phone text-success"
                        : "fas fa-phone text-danger";

                      const studentIcon = isDestinationAnswered
                        ? "fas fa-phone text-success"
                        : "fas fa-phone text-danger";

                      return (
                        <li
                          key={index}
                          className={index % 2 === 0 ? "" : "timeline-inverted"}
                        >
                          <div className={`timeline-badge ${badgeColor}`}>
                            <i className="fas fa-phone" />
                          </div>

                          <div
                            className="timeline-panel"
                            style={{
                              boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
                              borderRadius: "5px",
                            }}
                          >
                            <div className="timeline-heading">
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                {call.call_start_time_ && (
                                  <span
                                    style={{
                                      color: "green",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    {new Date(
                                      call.call_start_time_,
                                    ).toLocaleString()}
                                  </span>
                                )}

                                {call.call_end_time_ && (
                                  <span
                                    style={{
                                      color: "red",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    {new Date(
                                      call.call_end_time_,
                                    ).toLocaleString()}
                                  </span>
                                )}
                              </div>

                              <div style={{ textAlign: "center" }}>
                                <div
                                  style={{
                                    display: "inline-block",
                                    marginRight: "30px",
                                  }}
                                >
                                  <h4 className="timeline-title">
                                    {call.agent_name}{" "}
                                    <i className={agentIcon}></i>
                                  </h4>

                                  <p
                                    style={{
                                      color: "orange",
                                      marginBottom: "3px",
                                    }}
                                  >
                                    {call.call_duration_hms}
                                  </p>
                                </div>

                                <div
                                  style={{
                                    display: "inline-block",
                                  }}
                                >
                                  <h5 className="timeline-title">
                                   {call.employee_name}<i className={studentIcon}></i>
                                  </h5>

                                  <p style={{ color: "orange" }}>
                                    {call.conversation_duration_hms}
                                  </p>
                                </div>
                              </div>
                            </div>

                            <div className="timeline-body">
                              {call.aws_call_recording_file && (
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                  }}
                                >
                                  <AudioPlayer
                                    src={call.aws_call_recording_file}
                                  />
                                </div>
                              )}
                            </div>
                          </div>
                        </li>
                      );
                    })}
                  </ul>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SedCallLogs;
